import tableOfContents from "./tableOfContents";
import { enableAccordions, disableAccordions } from "../utils/accordions";
import { debounce } from "../utils/performance";
import { mediaMin } from "../utils/breakpoints";

export default function(el) {
    let accordionsInitialized = false;

    const handleResizeEvent = debounce(() => {
        if (!mediaMin("md")) {
            if (!accordionsInitialized) {
                enableAccordions(el);
                accordionsInitialized = true;
            }
        } else {
            if (accordionsInitialized) {
                disableAccordions(el);
                accordionsInitialized = false;
            }
        }
    }, 150);

    window.addEventListener("resize", handleResizeEvent);
    handleResizeEvent();

    tableOfContents(el, "btn-bounded--active");
}
